<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Admin</p>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="confirmAddAdmin">
          <div class="field">
            <div class="control has-icons-left">
              <input
                class="input"
                ref="newAdminQuery"
                placeholder="Email or user id"
                v-model="newAdminQuery"
                :disabled="isAddingAdmin"
              />
              <span class="icon is-small is-left">
                <i class="icon-mail"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="newAdminQueryError">{{ newAdminQueryError }}</p>
          </div>

          <input type="submit" style="display: none" />
        </form>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="addAdminError">
          {{ addAdminError }}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-right">
            <button class="button" @click="cancelAddMember" :disabled="isAddingAdmin">
              Cancel
            </button>
            <button
              class="button is-primary"
              @click="confirmAddAdmin"
              :class="{ 'is-loading': isAddingAdmin }"
              :disabled="isAddingAdmin"
            >
              Add admin
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { ADD_ADMIN } from './gpsDeviceStore'

export default {
  name: 'GPSDeviceAddAdminModal',

  props: {
    gpsDeviceStorePath: {
      type: String,
      required: true
    },

    gps: {
      type: Object,
      reqired: true
    }
  },

  data() {
    return {
      newAdminQuery: null,
      isAddingAdmin: false,
      newAdminQueryError: null,
      addAdminError: null
    }
  },

  mounted() {
    this.$refs.newAdminQuery.focus()
  },

  methods: {
    cancelAddMember() {
      this.$emit('cancelled')
    },

    async confirmAddAdmin() {
      if (this.newAdminQuery === null || this.newAdminQuery === '') {
        this.newAdminQueryError = 'Email/user id can not be empty'
        return
      }

      this.addAdminError = null
      this.isAddingAdmin = true

      try {
        const addAdminAction = `${this.gpsDeviceStorePath}/${ADD_ADMIN}`
        await this.$store.dispatch(addAdminAction, {
          deviceId: this.gps.deviceId,
          userQuery: this.newAdminQuery
        })

        this.$emit('succeeded')
      } catch (error) {
        if (error && error.message && error.message.includes('status code 404')) {
          this.addAdminError = 'User not found'
        } else {
          this.addAdminError = error || 'Something went wrong'
        }
      } finally {
        this.isAddingAdmin = false
      }
    }
  },

  watch: {
    newAdminQuery() {
      this.newAdminQueryError = null
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card-head {
  border-bottom: 0;
}

.modal-card-foot {
  border-top: 0;
}

.notification {
  margin-top: 1em;
}
</style>
